export const SET_VIEW = "app/ROSTER_LEAVE/SET_VIEW";
export const SET_VIEW_MONTH = "app/ROSTER_LEAVE/SET_VIEW_MONTH";
export const SET_VIEW_YEAR = "app/ROSTER_LEAVE/SET_VIEW_YEAR";
export const SET_YEAR = "app/ROSTER_LEAVE/SET_YEAR";
export const TOGGLE_ALLOWANCE = "app/ROSTER_LEAVE/TOGGLE_ALLOWANCE";
export const TOGGLE_LEAVE = "app/ROSTER_LEAVE/TOGGLE_LEAVE";
export const TOGGLE_VIEW = "app/ROSTER_LEAVE/TOGGLE_VIEW";
export const TOGGLE_APPROVE = "app/ROSTER_LEAVE/TOGGLE_APPROVE";
export const TOGGLE_HISTORY = "app/ROSTER_LEAVE/TOGGLE_HISTORY";

export const ADD_LEAVE = "app/ROSTER_LEAVE/ADD_LEAVE";
export const ADD_LEAVE_SUCCESS = "app/ROSTER_LEAVE/ADD_LEAVE_SUCCESS";
export const ADD_LEAVE_FAILURE = "app/ROSTER_LEAVE/ADD_LEAVE_FAILURE";

export const EDIT_LEAVE = "app/ROSTER_LEAVE/EDIT_LEAVE";
export const EDIT_LEAVE_SUCCESS = "app/ROSTER_LEAVE/EDIT_LEAVE_SUCCESS";
export const EDIT_LEAVE_FAILURE = "app/ROSTER_LEAVE/EDIT_LEAVE_FAILURE";

export const GET_VIEW_DATA = "app/ROSTER_LEAVE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/ROSTER_LEAVE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/ROSTER_LEAVE/GET_VIEW_DATA_FAILURE";

export const FETCH_LEAVE = "app/ROSTER_LEAVE/FETCH_LEAVE";
export const FETCH_LEAVE_SUCCESS = "app/ROSTER_LEAVE/FETCH_LEAVE_SUCCESS";
export const FETCH_LEAVE_FAILURE = "app/ROSTER_LEAVE/FETCH_EMPLOYEE_FAILURE";

export const SET_ALLOWANCE = "app/ROSTER_LEAVE/SET_ALLOWANCE";
export const SET_ALLOWANCE_SUCCESS = "app/ROSTER_LEAVE/SET_ALLOWANCE_SUCCESS";
export const SET_ALLOWANCE_FAILURE = "app/ROSTER_LEAVE/SET_ALLOWANCE_FAILURE";

export const DELETE_LEAVE = "app/ROSTER_LEAVE/DELETE_LEAVE";
export const DELETE_LEAVE_SUCCESS = "app/ROSTER_LEAVE/DELETE_LEAVE_SUCCESS";
export const DELETE_LEAVE_FAILURE = "app/ROSTER_LEAVE/DELETE_LEAVE_FAILURE";

export const GET_YEARS = "app/ROSTER_LEAVE/GET_YEARS";
export const GET_YEARS_SUCCESS = "app/ROSTER_LEAVE/GET_YEARS_SUCCESS";
export const GET_YEARS_FAILURE = "app/ROSTER_LEAVE/GET_YEARS_FAILURE";

export const FETCH_HISTORY = "app/ROSTER_LEAVE/FETCH_HISTORY";
export const FETCH_HISTORY_SUCCESS = "app/ROSTER_LEAVE/FETCH_HISTORY_SUCCESS";
export const FETCH_HISTORY_FAILURE = "app/ROSTER_LEAVE/FETCH_HISTORY_FAILURE";

export const FETCH_REQUESTS = "app/ROSTER_LEAVE/FETCH_REQUESTS";
export const FETCH_REQUESTS_SUCCESS = "app/ROSTER_LEAVE/FETCH_REQUESTS_SUCCESS";
export const FETCH_REQUESTS_FAILURE = "app/ROSTER_LEAVE/FETCH_REQUESTS_FAILURE";

export const APRROVE_LEAVE = "app/ROSTER_LEAVE/APRROVE_LEAVE";
export const APRROVE_LEAVE_SUCCESS = "app/ROSTER_LEAVE/APRROVE_LEAVE_SUCCESS";
export const APRROVE_LEAVE_FAILURE = "app/ROSTER_LEAVE/APRROVE_LEAVE_FAILURE";

export const FETCH_MONTH = "app/ROSTER_LEAVE/FETCH_MONTH";
export const FETCH_MONTH_SUCCESS = "app/ROSTER_LEAVE/FETCH_MONTH_SUCCESS";
export const FETCH_MONTH_FAILURE = "app/ROSTER_LEAVE/FETCH_MONTH_FAILURE";

export const GET_HISTORY = "app/ROSTER_LEAVE/GET_HISTORY";
export const GET_HISTORY_SUCCESS = "app/ROSTER_LEAVE/GET_HISTORY_SUCCESS";
export const GET_HISTORY_FAILURE = "app/ROSTER_LEAVE/GET_HISTORY_FAILURE";

export const GET_HOME_LEAVES = "app/ROSTER_LEAVE/GET_HOME_LEAVES";
export const GET_HOME_LEAVES_SUCCESS =
  "app/ROSTER_LEAVE/GET_HOME_LEAVES_SUCCESS";
export const GET_HOME_LEAVES_FAILURE =
  "app/ROSTER_LEAVE/GET_HOME_LEAVES_FAILURE";

export const UPDATE_LEAVE_EMP = "app/ROSTER_LEAVE/UPDATE_LEAVE_EMP";

export const DELETE_FILE = "app/ROSTER_LEAVE/DELETE_FILE";
export const DELETE_FILE_SUCCESS = "app/ROSTER_LEAVE/DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "app/ROSTER_LEAVE/DELETE_FILE_FAILURE";
export const TOGGLE_FILE_DEL = "app/ROSTER_LEAVE/TOGGLE_FILE_DEL";

export const FETCH_REPORT_LIST = "app/ROSTER_LEAVE/FETCH_REPORT_LIST";
export const FETCH_REPORT_LIST_SUCCESS =
  "app/ROSTER_LEAVE/FETCH_REPORT_LIST_SUCCESS";
export const FETCH_REPORT_LIST_FAILURE =
  "app/ROSTER_LEAVE/FETCH_REPORT_LIST_FAILURE";

export const GET_ACCRUAL_PERIOD = "app/ROSTER_LEAVE/GET_ACCRUAL_PERIOD";
export const GET_ACCRUAL_PERIOD_SUCCESS =
  "app/ROSTER_LEAVE/GET_ACCRUAL_PERIOD_SUCCESS";
export const GET_ACCRUAL_PERIOD_FAILURE =
  "app/ROSTER_LEAVE/GET_ACCRUAL_PERIOD_FAILURE";

export const GET_ACCRUAL_LEAVE = "app/ROSTER_LEAVE/GET_ACCRUAL_LEAVE";
export const GET_ACCRUAL_LEAVE_SUCCESS =
  "app/ROSTER_LEAVE/GET_ACCRUAL_LEAVE_SUCCESS";
export const GET_ACCRUAL_LEAVE_FAILURE =
  "app/ROSTER_LEAVE/GET_ACCRUAL_LEAVE_FAILURE";

export const EXPORT_ACCRUAL = "app/ROSTER_LEAVE/EXPORT_ACCRUAL";
export const EXPORT_ACCRUAL_SUCCESS = "app/ROSTER_LEAVE/EXPORT_ACCRUAL_SUCCESS";
export const EXPORT_ACCRUAL_FAILURE = "app/ROSTER_LEAVE/EXPORT_ACCRUAL_FAILURE";

export const GET_AVG_HOURS = "app/ROSTER_LEAVE/GET_AVG_HOURS";
export const GET_AVG_HOURS_SUCCESS = "app/ROSTER_LEAVE/GET_AVG_HOURS_SUCCESS";
export const GET_AVG_HOURS_FAILURE = "app/ROSTER_LEAVE/GET_AVG_HOURS_FAILURE";
